export const flexbox = {
  alignContent: {
    scale: true,
  },
  alignItems: {
    scale: true,
  },
  alignSelf: {
    scale: true,
  },
  flex: {
    scale: true,
  },
  flexBasis: {
    scale: true,
  },
  flexDirection: {
    scale: true,
  },
  flexFlow: {
    scale: true,
  },
  flexGrow: {
    scale: true,
  },
  flexShrink: {
    scale: true,
  },
  flexWrap: {
    scale: true,
  },
  gap: {
    scale: 'space',
  },
  justifyContent: {
    scale: true,
  },
  justifyItems: {
    scale: true,
  },
  justifySelf: {
    scale: true,
  },
  order: {
    scale: true,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Flexbox = typeof flexbox;
